import { useMemo } from 'react';
var useTags = function useTags(userRole) {
  return useMemo(function () {
    var tags = [];
    tags.push("chat_customer:".concat(userRole));
    return tags;
  }, [userRole]);
};
export default useTags;